import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loader = ({ loading = true, message, onClose, btnName = "OK" }) => {
  if (!loading && !message) return null;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        {loading && !message ? (
          <CircularProgress style={{ color: "#2e3192" }} />
        ) : (
          <>
            <div
              style={styles.message}
              dangerouslySetInnerHTML={{ __html: message }}
            />
            <button style={styles.button} onClick={onClose}>
              {btnName}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 30,
    minWidth: 90,
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
  message: {
    marginBottom: 20,
  },
  button: {
    backgroundColor: "#2e3192",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: 4,
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default Loader;
